/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Exec_StrictInputs */

const en_inbox_exec_strict = /** @type {(inputs: Inbox_Exec_StrictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strict: ask after every step`)
};

const id_inbox_exec_strict = /** @type {(inputs: Inbox_Exec_StrictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ketat: tanya tiap langkah`)
};

/**
* | output |
* | --- |
* | "Strict: ask after every step" |
*
* @param {Inbox_Exec_StrictInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_exec_strict = /** @type {((inputs?: Inbox_Exec_StrictInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Exec_StrictInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_exec_strict(inputs)
	return en_inbox_exec_strict(inputs)
});